import { useEffect } from 'react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { ROUTES } from '@/lib/constants';
import logger from '@/lib/logger';

// Unknown paths go back to the start of the journey, as the SPA did before the router migration.
const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    logger.warn('Unknown route, returning to home:', location.pathname);
    navigate({ to: ROUTES.HOME, replace: true });
  }, [location.pathname, navigate]);

  return null;
};

export default NotFound;
